export const enum EPurchaseStep {
  Buying = 'buying',
  Checkout = 'checkout',
  PaymentOptions = 'payment-options',
  PaidSuccess = 'paid-success',
}
